<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <div class="row">
          <div class="col-8">
            <h3 class="mt-1"><span class="badge badge-primary">{{ productGroup.order }}</span>  {{ productGroup.name }}</h3>
            <div v-if="userHasPerms(['Manage products'])">
              <router-link
                v-b-tooltip.hover
                title="Edit"
                :to="{
                  name: 'product-groups-edit',
                  params: { id: productGroup.id },
                }"
                class="text-primary table-action-icon ml-0"
              >
                <i class="lni lni-pencil"></i>
              </router-link>

              <span
                v-b-tooltip.hover
                style="cursor: pointer"
                title="Delete"
                @click="confirmDelete(productGroup.id)"
                class="text-danger table-action-icon"
              >
                <i class="lni lni-trash"></i>
              </span>
            </div>
          </div>
          <div class="col-4">
            <v-lazy-image
              v-if="productGroup.image"
              :src="productGroup.image"
              class="img-fluid maxHeight200"
            />
          </div>
        </div>
        <table class="table table-sm mt-3">
       
          <table-row icon="lni-database" :noBorder="true" />

          <table-row label="Id">{{ productGroup.id }} </table-row>

          <table-row label="Created"
            >{{
              moment(new Date(productGroup.created_at)).format(
                "DD MMM YYYY, HH:mm:ss"
              )
            }}
          </table-row>
          <table-row label="Updated"
            >{{
              moment(new Date(productGroup.updated_at)).format(
                "DD MMM YYYY, HH:mm:ss"
              )
            }}
          </table-row>
        </table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import productGroupRepo from "@/api/repos/productGroupRepo";
import tableRow from "@/components/common/TableRow";

export default {
  props: ["id"],

  components: {
    tableRow,
  },

  mounted() {
    this.getProductGroup();
  },

  data() {
    return {
      loading: false,
      productGroup: {},
    };
  },

  methods: {
    async getProductGroup() {
      try {
        this.loading = true;
        let { data } = await productGroupRepo.get(this.id);
        this.productGroup = data.product_group;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async deleteProductGroup(id) {
      this.isBusy = true;
      try {
        await productGroupRepo.delete(id);
        this.$emit("productGroupUpdated");
      } catch (error) {
        console.log(error);
      } finally {
        this.isBusy = false;
      }
    },
    confirmDelete(id) {
      this.$bvModal
        .msgBoxConfirm(
          "Please confirm that you want to delete the productGroup.",
          {
            title: "Please Confirm",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((confirm) => (confirm ? this.deleteProductGroup(id) : false))
        .catch((error) => console.log(error));
    },
  },
};
</script>
